import React from "react";
import { PlusCircleOutlined, CalendarOutlined, BellOutlined, FileTextOutlined, EnvironmentOutlined, PartitionOutlined } from "@ant-design/icons";
import { AirplaneOutlined } from "../../../../components/icons/SvgIcons";
import QuickAccessWidget from "../common/QuickAccessWidget";

const OpsQuickAccessWidget = (props) => {
    const items = [
        {
            label: "新增航班计划",
            path: "/flightSchedule/editor/new",
            icon: <PlusCircleOutlined />,
            primary: true,
            permission: "schedule:create", // 创建计划权限
        },
        {
            label: "草稿计划",
            path: "/flightSchedule/drafts",
            icon: <FileTextOutlined />,
            primary: true,
            permission: "schedule:read", // 读取计划权限
        },
        {
            label: "正式计划",
            path: "/flightSchedule/list",
            icon: <CalendarOutlined />,
            primary: true,
            permission: "schedule_official:read",
        },
        {
            label: "航班监控",
            path: "/operation/flight-monitor",
            icon: <AirplaneOutlined />,
            primary: true,
            permission: "flight_operation:read_basic", // 基础读取权限即可
        },
        {
            label: "通知中心",
            path: "/workspace/notification-center",
            icon: <BellOutlined />,
            primary: false,
            // 通知中心对所有用户开放，不配置权限
        },
        {
            label: "航段管理",
            path: "/master-data/flight-legs",
            icon: <PartitionOutlined />,
            primary: false,
            permission: "masterdata:read",
        },
        {
            label: "航线管理",
            path: "/master-data/flight-routes",
            icon: <EnvironmentOutlined />,
            primary: false,
            permission: "masterdata:read",
        },
    ];

    return <QuickAccessWidget title="运行控制中心" items={items} viewMorePath="/operation/flight-monitor" showTitle={false} showMenu={false} {...props} />;
};

export default OpsQuickAccessWidget;
